<template>
  <div class="w-full flex" v-loading="loading">
    <div class="w-4/12 p-2">
      <div class="border rounded-md px-4">
        <el-form :model="form" ref="form">
          <!-- Report Period Type -->
          <el-form-item prop="dataForm">
            <h5 class="text-base font-bold text-black mt-2">Report Period</h5>
            <el-select
              v-model="form.dataForm"
              @change="onChangePicker"
              placeholder="Select Report Period"
              class="w-full"
            >
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- Period Range -->
          <h5 class="text-base font-bold text-black my-2">Period Range</h5>
          <div class="flex justify-between">
            <el-form-item prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                :picker-options="datePickerOptions"
                :type="periodDatePickerType"
                placeholder="Start Period"
                value-format="yyyy-MM-dd"
                @change="validateDate"
                class="mr-1"
                style="width: 98%;"
              />
            </el-form-item>
            <el-form-item prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                :picker-options="datePickerOptions"
                :type="periodDatePickerType"
                placeholder="End Period"
                value-format="yyyy-MM-dd"
                @change="validateDate"
                class="ml-1"
                style="width: 98%;"
              />
            </el-form-item>
          </div>
          <!-- Type Sensor -->
          <el-form-item>
            <h5 class="text-base font-bold text-black">Sensor Type</h5>
            <el-select
              v-model="form.sensorType"
              @change="onChangeTypeSensor"
              placeholder="Select Sensor Type"
              class="w-full"
            >
              <el-option
                v-for="item in sensorTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- Dropdown Report -->
        <h5 class="text-base font-bold text-black">Sub Devices</h5>
        <div class="border mt-2 h-56 rounded overflow-auto py-2">
          <el-tree
            class=""
            :data="checkboxes"
            show-checkbox
            node-key="id"
            @check="CheckedNodes"
            :default-expanded-keys="[]"
            :default-checked-keys="[]"
          />
        </div>

        <!-- Submit button -->
        <div class="flex mt-4 mb-4 justify-end">
          <el-button type="primary" @click="submit">Submit</el-button>
        </div>
      </div>
    </div>
    <div class="w-8/12 p-2">
      <div class="border rounded-md p-3">
        <div v-if="chartBarVisible">
          <div class="flex justify-between">
            <div>
              <img
                src="@/assets/images/logo-corp.png"
                alt="logo-corp"
                class="h-16"
              />
            </div>
            <div class="flex">
              <el-tooltip
                class="item"
                effect="dark"
                content="Download"
                placement="top-start" >
                <el-dropdown @command="downloadReport" trigger="click">
                  <div
                    class="rounded-full h-10 w-10 bg-blue-600 flex items-center justify-center text-white hover:opacity-75"
                  >
                    <i class="el-icon-download text-xl"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="'pdf'">PDF</el-dropdown-item>
                    <el-dropdown-item :command="'excel'">Excel</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-tooltip>
            </div>
          </div>
          <div class="bg-white w-full flex justify-center">
            <bar-chart
              ref="canvas"
              style="width: 100%;"
              :height="200"
              :chart-data="dataCollectionReport"
              :options="chartOptionsReport"
            />
          </div>
          <div class="mt-5">
            <vue-good-table
              :columns="tableColumns"
              :rows="tableRows"
              :line-numbers="true"
              styleClass="vgt-table bordered striped condensed"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 10
              }"
            >
              <template slot="table-row" slot-scope="props">
                <span
                  :id="`${props.column.field}-${props.index}`"
                  class="text-sm"
                >
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
        <div v-else class="h-64 text-center">
          <i class="el-icon-info"></i> Please do fulfill fields on the left side
          first to display report data
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/Chart/BarChart.js'
import averageReportService from './averageReportService'

export default {
  components: {
    BarChart
  },
  mixins: [averageReportService]
}
</script>
